import { Box, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { ValueCell } from "./ValueCell";

interface UpdatedFieldContainerProps {
  fieldKey: string;
  previousValue: unknown;
  newValue: unknown;
}

export function UpdatedFieldContainer(props: UpdatedFieldContainerProps) {
  const { fieldKey, previousValue, newValue } = props;

  return (
    <Stack spacing={0.25}>
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Box minWidth={80}></Box>
        <Text inline variant="body2" bold>
          {fieldKey}
        </Text>
      </Stack>

      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Text inline variant="body2" minWidth={80}>
          New:
        </Text>
        <ValueCell value={newValue} />
      </Stack>

      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Text inline variant="body2" minWidth={80} color="text.secondary">
          Previous:
        </Text>
        <ValueCell value={previousValue} muted />
      </Stack>
    </Stack>
  );
}
